export default __webpack_public_path__ + "static/media/privacy-recontact.36ff74ef.pdf";